export default {
  computed: {
    /** Errors */
    chooseError() {
      return {
        condition: 'required',
        error: this.chooseErrorMessage,
      }
    },
    numericError() {
      return {
        condition: 'numeric',
        error: this.numbersErrorMessage,
      }
    },
    requiredError() {
      return {
        condition: 'required',
        error: this.requiredErrorMessage,
      }
    },
  },
}
